import {AbstractControl} from '@angular/forms';
import {onlyNumbers} from '@clients/shared/utilities';

export function validatePhoneNumber(c: AbstractControl): {[key: string]: any} | null {
    const test = c.value && onlyNumbers(c.value).length === 10;

    return test ? null : {invalidPhoneNumber: c.value};
}
